import { createAction } from 'redux-actions';
import { VISITOR_UPDATED } from '../constants/actionTypes';
export const visitorUpdated = createAction(VISITOR_UPDATED, ({
  threadId,
  visitor
}) => ({
  threadId,
  visitor
}));